/* COWBELL SIZE SELECT v3 (2026-09-25)
   Product pages (Dawn 15.2): the Size pill is NOT pre-checked on load; the legend reads
   "Size: Select" until one is tapped (Mike's wording, 2026-09-20). No other added text.
   LIVE for everyone since 2026-09-20 (Mike: "push it live").
   - Add to Cart is aria-disabled until a size is tapped (Dawn's product-form ignores submits while
     aria-disabled); tapping it just pulses the size pills. Label stays "Add to Cart".
   - Color taps still work (Dawn re-renders with the first size checked; we uncheck it again).
   - The first size tap hands control back to Dawn: price ladder, variant id, cart, all native.
   - Links with ?variant= keep their color; the size still needs a tap.
   v3 (Mike 09-25): Meta catalog cards, Google Shopping and the pinned collection card link to ONE size
   (?variant=<Ivory / 4XL>), so with no size picked the page showed the 4XL price ($41.95). Now, when the
   linked size costs more than the cheapest size of that colour, we quietly select the cheapest size
   through Dawn (the same path as a colour tap: Dawn renders price, compare-at, URL and cart id) and
   un-check it again. The price stays hidden (space kept) until that render lands; the theme.liquid tag
   hides it from first paint on ?variant= links, so the higher price never shows. Tapping 4XL still
   shows $41.95.
   Preview gate: until LIVE is true this only runs with ?cowbell_size=on (remembered in localStorage;
   ?cowbell_size=off forgets it). Revert = remove the script tag from layout/theme.liquid.
*/
(function () {
  'use strict';
  var LIVE = true;
  try {
    var q = window.location.search || '';
    if (/[?&]cowbell_size=(on|1)(&|$)/.test(q)) window.localStorage.setItem('cowbellSizeSelect', 'on');
    if (/[?&]cowbell_size=(off|0)(&|$)/.test(q)) window.localStorage.removeItem('cowbellSizeSelect');
  } catch (e) {}
  // the theme.liquid tag adds this class on ?variant= links (price hidden from first paint, 2.5 s failsafe there)
  var WAIT = 'cowbell-price-wait';
  function reveal() { document.documentElement.classList.remove(WAIT); }
  // Same test as the theme.liquid tag. Google Shopping ads SHOW the linked size's price and Google requires the
  // landing price to match; Google's and Meta's crawlers check product pages against the catalog price. Those
  // visits keep the linked size's price exactly as rendered.
  function wantsBasePrice() {
    var q = window.location.search || '';
    return /[?&]variant=/.test(q) && !/[?&](gclid|gbraid|wbraid|srsltid)=|[?&]utm_source=google/i.test(q) &&
      !/bot|crawl|spider|slurp|facebookexternalhit|facebookcatalog|meta-externalagent|Google-|GoogleOther|Mediapartners|Lighthouse/i.test(navigator.userAgent || '');
  }
  var enabled = LIVE;
  try { enabled = enabled || window.localStorage.getItem('cowbellSizeSelect') === 'on'; } catch (e) {}
  if (!enabled) { reveal(); return; }

  var SIZES = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  var chosen = false;
  var switching = false; // our own quiet cheapest-size selection, not a customer tap
  var flashTimer = null;

  function sizeFieldset() {
    var fss = document.querySelectorAll('variant-selects fieldset');
    for (var i = 0; i < fss.length; i++) {
      var lg = fss[i].querySelector('legend');
      if (lg && /^\s*size/i.test(lg.textContent)) return fss[i];
    }
    for (var j = 0; j < fss.length; j++) {
      var r = fss[j].querySelector('input[type=radio]');
      if (r && SIZES.indexOf(String(r.value).toUpperCase()) >= 0) return fss[j];
    }
    return null;
  }
  function submitButton() {
    return document.querySelector('product-form form[action*="/cart/add"] button[type=submit], product-form .product-form__submit');
  }
  // After a click on Add to Cart with no size: desktop shows this in red next to "Size:", phones pulse the pills.
  var WARN = ': Choose size to add this item';
  var warned = false;
  function isDesktop() { return !(window.matchMedia && window.matchMedia('(max-width: 749px)').matches); }
  function setLegendPrompt(fs) {
    var lg = fs.querySelector('legend');
    if (!lg) return;
    var span = lg.querySelector('.cowbell-size-value');
    if (!span) { span = document.createElement('span'); span.className = 'cowbell-size-value'; lg.appendChild(span); }
    var want = warned ? WARN : ': Select';
    if (span.textContent !== want) span.textContent = want;
    span.classList.toggle('cowbell-size-msg', warned);
  }
  // The button looks and feels normal (Mike, 09-20: no fading); aria-disabled only makes Dawn's product-form
  // ignore a submit, and the capture-phase click/submit guards below stop it before that anyway.
  function lockButton() {
    var btn = submitButton();
    if (!btn) return;
    if (btn.hasAttribute('disabled')) btn.removeAttribute('disabled');
    if (btn.getAttribute('aria-disabled') !== 'true') btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('cowbell-needs-size');
  }
  function unlockButton() {
    var btn = submitButton();
    if (!btn) return;
    btn.removeAttribute('aria-disabled');
    btn.classList.remove('cowbell-needs-size');
    var fs = sizeFieldset();
    var span = fs && fs.querySelector('legend .cowbell-size-value');
    if (span) span.classList.remove('cowbell-size-msg');
  }
  function apply() {
    if (chosen) return;
    var fs = sizeFieldset();
    if (!fs) return;
    var checked = fs.querySelector('input[type=radio]:checked');
    if (checked) checked.checked = false;
    setLegendPrompt(fs);
    lockButton();
  }
  function flash() {
    var fs = sizeFieldset();
    if (!fs) return;
    var r = fs.getBoundingClientRect();
    if (r.top < 0 || r.bottom > window.innerHeight) { try { fs.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { fs.scrollIntoView(); } }
    if (isDesktop()) { warned = true; setLegendPrompt(fs); return; }
    fs.classList.remove('cowbell-flash');
    void fs.offsetWidth;
    fs.classList.add('cowbell-flash');
    clearTimeout(flashTimer);
    flashTimer = setTimeout(function () { fs.classList.remove('cowbell-flash'); }, 2000);
  }
  function onChange(ev) {
    var t = ev.target;
    if (switching || !t || t.type !== 'radio') return;
    var fs = sizeFieldset();
    if (!fs || !fs.contains(t) || !t.checked) return;
    chosen = true;
    unlockButton();
  }
  function onClick(ev) {
    if (chosen) return;
    var btn = submitButton();
    if (!btn) return;
    if (btn === ev.target || btn.contains(ev.target)) { ev.preventDefault(); ev.stopPropagation(); flash(); }
  }
  function onSubmit(ev) {
    if (chosen) return;
    var f = ev.target;
    if (f && f.getAttribute && /\/cart\/add/.test(f.getAttribute('action') || '')) { ev.preventDefault(); ev.stopPropagation(); flash(); }
  }
  function injectCss() {
    if (document.getElementById('cowbell-size-select-css')) return;
    var st = document.createElement('style');
    st.id = 'cowbell-size-select-css';
    st.textContent = [
      '.product-form__submit.cowbell-needs-size,.product-form__submit.cowbell-needs-size[aria-disabled=true]{opacity:1!important;cursor:pointer!important}',
      'html.cowbell-price-wait product-info [id^="price-"]{visibility:hidden}',
      'legend .cowbell-size-value.cowbell-size-msg{color:#c8102e;font-weight:600}',
      '@keyframes cowbellPulse{0%{box-shadow:0 0 0 0 rgba(255,106,0,.6)}100%{box-shadow:0 0 0 12px rgba(255,106,0,0)}}',
      'fieldset.cowbell-flash{animation:cowbellPulse .8s ease-out 2;border-radius:8px}'
    ].join('');
    document.head.appendChild(st);
  }
  // v3: the variant Dawn rendered (from ?variant=) and the market's variant list Shopify prints on every
  // product page (ShopifyAnalytics.meta: id, price in the shopper's currency, "Ivory / 4XL").
  function currentVariant() {
    var s = document.querySelector('variant-selects script[data-selected-variant]');
    try { return s ? JSON.parse(s.textContent) : null; } catch (e) { return null; }
  }
  function marketVariants() {
    try { var v = window.ShopifyAnalytics.meta.product.variants; return v && v.length ? v : null; } catch (e) { return null; }
  }
  // If the linked size costs more than the cheapest available size of the same colour, select that size
  // through Dawn and return true (Dawn fetches and renders it; apply() un-checks it when the render lands).
  function selectCheapestSize() {
    var fs = sizeFieldset(), cur = currentVariant(), list = marketVariants();
    if (!fs || !cur || !cur.options || !list) return false;
    var radios = Array.prototype.slice.call(fs.querySelectorAll('input[type=radio]'));
    var sizes = radios.map(function (r) { return r.value; });
    var si = -1;
    for (var i = 0; i < cur.options.length; i++) if (sizes.indexOf(cur.options[i]) >= 0) { si = i; break; }
    if (si < 0) return false;
    var best = null;
    list.forEach(function (v) {
      var o = String(v.public_title || '').split(' / ');
      if (o.length !== cur.options.length) return;
      for (var k = 0; k < o.length; k++) if (k !== si && o[k] !== cur.options[k]) return;
      var at = sizes.indexOf(o[si]), r = radios[at];
      if (!r || r.disabled || r.classList.contains('disabled')) return;
      if (!best || v.price < best.price || (v.price === best.price && at < best.at)) best = { price: v.price, at: at };
    });
    if (!best || !(best.price < cur.price)) return false;
    var radio = radios[best.at], realId = radio.id;
    document.documentElement.classList.add(WAIT);
    switching = true;
    try {
      // Dawn re-focuses the "tapped" option after it renders, which scrolls phones down to the pills; a
      // borrowed id that no longer exists after the render keeps the page still.
      radio.id = 'cowbell-cheapest-size';
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    } finally {
      radio.id = realId;
      switching = false;
    }
    lockButton(); // Dawn greys the button while it fetches; keep it looking normal (Mike: no fading)
    return true;
  }
  function revealAfterRender() {
    var done = false;
    function finish() { if (done) return; done = true; reveal(); }
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        var off = subscribe(PUB_SUB_EVENTS.variantChange, function () { finish(); if (typeof off === 'function') off(); });
      }
    } catch (e) {}
    setTimeout(finish, 2500);
  }
  function start() {
    var info = document.querySelector('product-info');
    if (!info || !sizeFieldset()) { reveal(); return; }
    injectCss();
    apply();
    // product-info.js and product-form.js load after this file (they sit in the section, we sit in <head>).
    // Dawn's option-change handler needs BOTH defined (it resets the product-form first; before product-form.js
    // runs that throws "toggleSubmitButton is not a function" and nothing renders), so wait for both.
    if (wantsBasePrice()) {
      var go = function () {
        var switched = false;
        try { switched = !chosen && selectCheapestSize(); } catch (e) { switched = false; }
        if (switched) revealAfterRender(); else reveal();
      };
      setTimeout(reveal, 2500);
      var ce = window.customElements;
      if (ce && ce.whenDefined && window.Promise) {
        var need = [ce.whenDefined('product-info')];
        if (info.querySelector('product-form') || document.querySelector('product-form')) need.push(ce.whenDefined('product-form'));
        Promise.all(need).then(go);
      } else go();
    } else reveal();
    document.addEventListener('change', onChange, true);
    document.addEventListener('click', onClick, true);
    document.addEventListener('submit', onSubmit, true);
    var pending = null;
    var mo = new MutationObserver(function () {
      if (chosen) { mo.disconnect(); return; }
      clearTimeout(pending);
      pending = setTimeout(apply, 40);
    });
    mo.observe(info, { childList: true, subtree: true });
    setTimeout(apply, 250);
    setTimeout(apply, 1200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
